import { render, staticRenderFns } from "./ActionConfirmation.vue?vue&type=template&id=81f56f0a&scoped=true"
import script from "./ActionConfirmation.vue?vue&type=script&lang=ts"
export * from "./ActionConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f56f0a",
  null
  
)

export default component.exports